/*
 * Tensiko : page collection (filtres et tri).
 * Amélioration progressive : sans ce fichier, le formulaire reste ouvert et s'envoie avec le bouton « Appliquer ».
 * - ordinateur : barre toujours ouverte, filtres en menus déroulants (un seul ouvert, Échap ou clic extérieur pour fermer) ;
 * - mobile : barre repliée derrière « Filtres et tri », filtres en accordéons ;
 * - cases à cocher et tri : envoi automatique.
 */
(() => {
  const desktop = window.matchMedia('(min-width: 750px)');

  function init(form) {
    const panel = form.querySelector('[data-tensiko-toolbar]');
    const filters = Array.from(form.querySelectorAll('[data-tensiko-filter]'));

    form.querySelectorAll('[data-tensiko-nojs]').forEach((el) => {
      el.hidden = true;
    });

    const sync = () => {
      if (panel) panel.open = desktop.matches;
      filters.forEach((f) => {
        f.open = false;
      });
    };
    sync();
    desktop.addEventListener('change', sync);

    // Sur ordinateur, le titre « Filtres et tri » n'est pas un interrupteur
    panel?.querySelector('summary')?.addEventListener('click', (event) => {
      if (desktop.matches) event.preventDefault();
    });

    // Un seul menu déroulant ouvert à la fois sur ordinateur
    filters.forEach((f) => {
      f.addEventListener('toggle', () => {
        if (!f.open || !desktop.matches) return;
        filters.forEach((other) => {
          if (other !== f) other.open = false;
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!desktop.matches) return;
      filters.forEach((f) => {
        if (f.open && !f.contains(event.target)) f.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      filters.forEach((f) => {
        if (f.open) {
          f.open = false;
          f.querySelector('summary')?.focus();
        }
      });
    });

    // Envoi automatique : cases à cocher et tri (les prix gardent le bouton « Appliquer »)
    form.addEventListener('change', (event) => {
      const target = event.target;
      if (target.matches('input[type="checkbox"], [data-tensiko-sort]')) {
        form.requestSubmit();
      }
    });

    // Ne pas envoyer de paramètres vides (URL propres)
    form.addEventListener('formdata', (event) => {
      for (const [key, value] of Array.from(event.formData.entries())) {
        if (value === '') event.formData.delete(key);
      }
    });
  }

  const start = () => document.querySelectorAll('[data-tensiko-filters]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
